import {Component} from "react";
import PropTypes from "prop-types";
import {Modal, ModalBody, ModalHeader, Progress} from "reactstrap";
import CheckIcon from "../../media/images/CheckIcon.mjs";
import CloseIcon from "../../media/images/CloseIcon.mjs";

/**
 * Progress in a window modal, both determined and undetermined
 * @type {Component}
 * @property {string|Component|JSX.Element} [title] Optional Modal window title
 * @property {string|Component|JSX.Element} [message] Optional message reported below the bar/icon
 * @property {number} [progress] A 0..100 number, missing => undetermined progressbar
 * @property {boolean} [success] If provided replaces bar with success/failure icon
 */
const ModalProgress = class extends Component {
	static propTypes = {
		/** Optional Modal window title */
		title: PropTypes.oneOfType([PropTypes.string,PropTypes.node]),
		/** If provided replaces bar with success/failure icon */
		success: PropTypes.bool,
		/** A 0..100 number, missing => undetermined progressbar */
		progress: PropTypes.number,
		/** Optional message reported below the bar/icon */
		message: PropTypes.oneOfType([PropTypes.string,PropTypes.node]),
	}
	render() {
		return (
			<Modal
				fade={false}
				isOpen={true}
				backdrop="static"
			>
				{ ( !! this.props.title ) && (
					<ModalHeader>
						{this.props.title}
					</ModalHeader>
				)}
				<ModalBody>
					{ typeof this.props.success === 'boolean' ? (
						<div align="center">
							{ this.props.success ? <CheckIcon style={{height:"3rem",fill:"#090"}} /> : <CloseIcon style={{height:"3rem",fill:"#c00"}} /> }
						</div>
					) : (
						typeof this.props.progress === 'number' ? (
							<Progress animated={true} value={this.props.progress} />
						) : (
							<Progress animated={true} value={100} striped />
						)
					)}
					{ ( !! this.props.message ) && (
						<div>
							{ this.props.message }
						</div>
					)}
				</ModalBody>
			</Modal>
		)
	}
}

export default ModalProgress;